import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IndustryTypeDropdownComponent } from './industry-type-dropdown.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
  ],
  declarations: [IndustryTypeDropdownComponent],
  exports: [IndustryTypeDropdownComponent],
})
export class IndustryTypeDropdownModule { }
